/**
 * CORE permission codes used by the web (`module.resource.action`).
 * Mirrors the backend `definePermissions('core', …)` in api/src/modules/core/permissions.ts.
 */
export const P = {
  company: { read: 'core.company.read', update: 'core.company.update' },
  department: { read: 'core.org.read', create: 'core.org.configure', update: 'core.org.configure', delete: 'core.org.configure' },
  costCenter: { read: 'core.org.read', create: 'core.org.configure', update: 'core.org.configure', delete: 'core.org.configure' },
  uom: { read: 'core.uom.read', create: 'core.uom.configure' },
  item: { read: 'core.item.read', create: 'core.item.create', update: 'core.item.update', delete: 'core.item.delete', export: 'core.item.export' },
  customer: {
    read: 'core.customer.read',
    create: 'core.customer.create',
    update: 'core.customer.update',
    delete: 'core.customer.delete',
    export: 'core.customer.export',
    updateCredit: 'core.customer.update_credit',
  },
  supplier: {
    read: 'core.supplier.read',
    create: 'core.supplier.create',
    update: 'core.supplier.update',
    delete: 'core.supplier.delete',
    export: 'core.supplier.export',
  },
  supplierBank: { update: 'core.supplier_bank.update', approve: 'core.supplier_bank.approve' },
  currency: { read: 'core.fx_rate.read', create: 'core.currency.configure', update: 'core.currency.configure' },
  fxRate: { read: 'core.fx_rate.read', create: 'core.fx_rate.create' },
  holiday: { read: 'core.org.read', create: 'core.calendar.configure', update: 'core.calendar.configure', delete: 'core.calendar.configure' },
  numberSeries: { read: 'core.number_series.configure', update: 'core.number_series.configure' },
  approvalRule: { configure: 'core.approval_rule.configure' },
  setting: { read: 'core.setting.read', propose: 'core.setting.propose', approve: 'core.setting.approve' },
  import: { run: 'core.import.run' },
} as const;
